import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  item: {
    position: 'relative',
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  image: {
    width: 120,
    cursor: 'pointer'
  },
  remove: {
    position: 'absolute',
    minWidth: 'inherit',
    borderRadius: '16px !important',
    padding: 8,
    height: 32,
    top: -8,
    right: -8
  }
}))

export {
  useStyles
}